import { useEffect, useState } from "react";
import {
    BarChart,
    Bar,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    Legend,
    ResponsiveContainer,
    ReferenceLine,
    Line,
    ComposedChart
} from "recharts";

export default function StackedBarChartProGroup({ chartData, percentArray }) {

    const [stackedData, setStackedData] = useState([]);


    var resData = {
        "2023/03": [
            {
                "month": "2023/03",
                "qty": 1966,
                "rev": 20919759.77,
                "reason": null
            },
            {
                "month": "2023/03",
                "qty": 165,
                "rev": 1439615.95,
                "reason": "Designer could not make it"
            },
            {
                "month": "2023/03",
                "qty": 84,
                "rev": 1136480.07,
                "reason": "Designer delayed, client cancelled"
            },
            {
                "month": "2023/03",
                "qty": 51,
                "rev": 458711.69,
                "reason": "QC reject cancelled"
            },
            {
                "month": "2023/03",
                "qty": 1,
                "rev": 1020,
                "reason": "Changed MRP later"
            }
        ],
        "2023/04": [
            {
                "month": "2023/04",
                "qty": 2208,
                "rev": 21628212.83,
                "reason": null
            },
            {
                "month": "2023/04",
                "qty": 91,
                "rev": 1334955.45,
                "reason": "Designer delayed, client cancelled"
            },
            {
                "month": "2023/04",
                "qty": 154,
                "rev": 1132775.39,
                "reason": "Designer could not make it"
            },
            {
                "month": "2023/04",
                "qty": 57,
                "rev": 439911.05,
                "reason": "QC reject cancelled"
            }
        ],
        "2023/05": [
            {
                "month": "2023/05",
                "qty": 2033,
                "rev": 22655418.4,
                "reason": null
            },
            {
                "month": "2023/05",
                "qty": 110,
                "rev": 994234.38,
                "reason": "Designer could not make it"
            },
            {
                "month": "2023/05",
                "qty": 76,
                "rev": 1216819.13,
                "reason": "Designer delayed, client cancelled"
            },
            {
                "month": "2023/05",
                "qty": 13,
                "rev": 26835.08,
                "reason": "Changed MRP later"
            },
            {
                "month": "2023/05",
                "qty": 21,
                "rev": 365829.18,
                "reason": "QC reject cancelled"
            }
        ],
        "2023/06": [
            {
                "month": "2023/06",
                "qty": 2021,
                "rev": 22651076.23,
                "reason": null
            },
            {
                "month": "2023/06",
                "qty": 131,
                "rev": 1194247.48,
                "reason": "Designer could not make it"
            },
            {
                "month": "2023/06",
                "qty": 39,
                "rev": 660951,
                "reason": "Designer delayed, client cancelled"
            },
            {
                "month": "2023/06",
                "qty": 15,
                "rev": 110152.5,
                "reason": "QC reject cancelled"
            }
        ],
        "2023/07": [
            {
                "month": "2023/07",
                "qty": 138,
                "rev": 1115534.17,
                "reason": "Designer could not make it"
            },
            {
                "month": "2023/07",
                "qty": 2153,
                "rev": 23870533.3,
                "reason": null
            },
            {
                "month": "2023/07",
                "qty": 60,
                "rev": 1186647.13,
                "reason": "Designer delayed, client cancelled"
            },
            {
                "month": "2023/07",
                "qty": 23,
                "rev": 241436.16,
                "reason": "QC reject cancelled"
            },
            {
                "month": "2023/07",
                "qty": 3,
                "rev": 15577.55,
                "reason": "Changed MRP later"
            }
        ],
        "2023/08": [
            {
                "month": "2023/08",
                "qty": 1841,
                "rev": 20254453.79,
                "reason": null
            },
            {
                "month": "2023/08",
                "qty": 144,
                "rev": 1511682.53,
                "reason": "Designer could not make it"
            },
            {
                "month": "2023/08",
                "qty": 72,
                "rev": 1054653.37,
                "reason": "Designer delayed, client cancelled"
            },
            {
                "month": "2023/08",
                "qty": 19,
                "rev": 249737,
                "reason": "QC reject cancelled"
            }
        ],
        "2023/09": [
            {
                "month": "2023/09",
                "qty": 2156,
                "rev": 25357753.81,
                "reason": null
            },
            {
                "month": "2023/09",
                "qty": 181,
                "rev": 1662853.79,
                "reason": "Designer could not make it"
            },
            {
                "month": "2023/09",
                "qty": 186,
                "rev": 2854240.53,
                "reason": "Designer delayed, client cancelled"
            },
            {
                "month": "2023/09",
                "qty": 47,
                "rev": 700310.78,
                "reason": "QC reject cancelled"
            },
            {
                "month": "2023/09",
                "qty": 1,
                "rev": 8265,
                "reason": "Client changed  mind"
            }
        ],
        "2023/10": [
            {
                "month": "2023/10",
                "qty": 2351,
                "rev": 28136577.41,
                "reason": null
            },
            {
                "month": "2023/10",
                "qty": 207,
                "rev": 1555367.9,
                "reason": "Designer could not make it"
            },
            {
                "month": "2023/10",
                "qty": 55,
                "rev": 762400.37,
                "reason": "QC reject cancelled"
            },
            {
                "month": "2023/10",
                "qty": 2,
                "rev": 50500,
                "reason": "Changed MRP later"
            },
            {
                "month": "2023/10",
                "qty": 206,
                "rev": 3216818.64,
                "reason": "Designer delayed, client cancelled"
            }
        ],
        "2023/11": [
            {
                "month": "2023/11",
                "qty": 2246,
                "rev": 25596637.62,
                "reason": null
            },
            {
                "month": "2023/11",
                "qty": 1,
                "rev": 990,
                "reason": "Changed MRP later"
            },
            {
                "month": "2023/11",
                "qty": 173,
                "rev": 1476262,
                "reason": "Designer could not make it"
            },
            {
                "month": "2023/11",
                "qty": 167,
                "rev": 2077258.35,
                "reason": "Designer delayed, client cancelled"
            },
            {
                "month": "2023/11",
                "qty": 21,
                "rev": 220414,
                "reason": "QC reject cancelled"
            }
        ],
        "2023/12": [
            {
                "month": "2023/12",
                "qty": 1915,
                "rev": 22666346.58,
                "reason": null
            },
            {
                "month": "2023/12",
                "qty": 121,
                "rev": 1350059.75,
                "reason": "Designer could not make it"
            },
            {
                "month": "2023/12",
                "qty": 77,
                "rev": 1378840,
                "reason": "Designer delayed, client cancelled"
            },
            {
                "month": "2023/12",
                "qty": 1,
                "rev": 17500,
                "reason": "Designer Changed pricing details later"
            }
        ],
        "2024/01": [
            {
                "month": "2024/01",
                "qty": 1796,
                "rev": 22659477.75,
                "reason": null
            },
            {
                "month": "2024/01",
                "qty": 104,
                "rev": 1010878.75,
                "reason": "Designer could not make it"
            },
            {
                "month": "2024/01",
                "qty": 95,
                "rev": 1463834,
                "reason": "Designer delayed, client cancelled"
            },
            {
                "month": "2024/01",
                "qty": 1,
                "rev": 19985,
                "reason": "Designer Changed pricing details later"
            }
        ],
        "2024/02": [
            {
                "month": "2024/02",
                "qty": 689,
                "rev": 8131538,
                "reason": null
            },
            {
                "month": "2024/02",
                "qty": 30,
                "rev": 340393,
                "reason": "Designer could not make it"
            },
            {
                "month": "2024/02",
                "qty": 13,
                "rev": 163103,
                "reason": "Designer delayed, client cancelled"
            },
            {
                "month": "2024/02",
                "qty": 1,
                "rev": 74000,
                "reason": "Designer Changed pricing details later"
            }
        ],
        "2024/03": [
            {
                "month": "2024/03",
                "qty": 7,
                "rev": 101250,
                "reason": null
            }
        ]
    }

    useEffect(() => {

        let tempChartData = chartData;

        let percentAge = percentArray;

        let index = 0;
        let collectArr = [];
        for (var key in tempChartData) {
            if (tempChartData.hasOwnProperty(key)) {
                // console.log(key + " -> " + tempChartData[key]);
                // console.log(tempChartData[key])
                // let tempObj = {
                //     name: key,
                //     // ['reason'+index]: index
                // }
                // console.log(tempObj)
    
                let tempData = {};
                for (let i = 0; i < tempChartData[key].length; i++) {
                    // console.log(tempChartData[key][i]);
                    // tempData[i]['reason'] = tempChartData[key][i];
                    tempData['reason_' + (i + 1)] = tempChartData[key][i];
                }
                let finalObj = { name: key, percentage: percentAge[index], ...tempData }
                // console.log({name: key, ...tempData})
                // console.log(finalObj);
                collectArr.push(finalObj);
                // console.log('----------------------------------------')
    
            }
            index++
        };
    
        console.log(collectArr);

        setStackedData(collectArr)

    }, [chartData])





    const CustomTooltip = ({ active, payload, label }) => {

        // console.log(payload);
        console.log(payload[0]);
        if (active && payload && payload.length) {
            return (
                <div className="custom-tooltip">
                    <span style={{ display: 'block' }}>{`${payload[0]?.payload?.reason_1?.reason}: ${payload[0]?.payload?.reason_1?.rev?.toLocaleString('en-IN')}`}</span>
                    <span style={{ display: 'block' }}>{`${payload[0]?.payload?.reason_2?.reason}: ${payload[0]?.payload?.reason_2?.rev?.toLocaleString('en-IN')}`}</span>
                    <span style={{ display: 'block' }}>{`${payload[0]?.payload?.reason_3?.reason}: ${payload[0]?.payload?.reason_3?.rev?.toLocaleString('en-IN')}`}</span>
                    <span style={{ display: 'block' }}>{`${payload[0]?.payload?.reason_4?.reason}: ${payload[0]?.payload?.reason_4?.rev?.toLocaleString('en-IN')}`}</span>                    
                    <span style={{ display: 'block' }}>{`Designer Cancel %: ${payload[0]?.payload?.percentage?.Designer_cancel_percent}%`}</span>


                    {/* <span style={{ display: 'block' }}>Total: {`
                    ${payload[0]?.payload?.reason_1?.rev + payload[0]?.payload?.reason_2?.rev + payload[0]?.payload?.reason_3?.rev + payload[0]?.payload?.reason_4?.rev }
                    
                    
                    `}</span> */}
                                        
                    
                </div>
            );
        }

        return null;
    };

    const CustomLegend = (props) => {
        const {payload} = props;
        return <div className="bar-legend">Months</div>
      }
  
    return (
        <ResponsiveContainer width="100%" height={400}>
            <ComposedChart
                data={stackedData}
                margin={{
                    top: 5,
                    right: 30,
                    left: 20,
                    bottom: 5,
                }}
            >
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="name" />
                <YAxis />
                <Tooltip content={<CustomTooltip />} />
                {/* <Legend content={<CustomLegend />} /> */}
                <Legend
                    payload={[
                    { value: "Designer delayed, client cancelled", id: "reason_1", color: '#0088FE' },
                    { value: "Designer could not make it", id: "reason_2", color: '#00C49F' },
                    { value: "Pricing Changed after Order placed", id: "reason_3", color: '#FFBB28' },
                    { value: "Other Designer Cancellation", id: "reason_4", color: '#FF8042' },                    
                    ]}
                />
                {/* <Tooltip  /> */}
                {/* <Legend /> */}
                <ReferenceLine y={0} stroke="#000" />


                <Bar dataKey="reason_1.rev" stackId="a" fill="#0088FE" />
                <Bar dataKey="reason_2.rev" stackId="a" fill="#00C49F" />
                <Bar dataKey="reason_3.rev" stackId="a" fill="#FFBB28" />
                <Bar dataKey="reason_4.rev" stackId="a" fill="#FF8042" />
                

                {/* <Line type="monotone" dataKey="percentage.Designer_cancel" stroke="#ff7300" /> */}



            </ComposedChart>
        </ResponsiveContainer>
    );
}